import { Form, Input } from 'antd';
import EmojiPicker from '../EmojiPicker';
import { Rule } from 'antd/es/form';
import { useTranslation } from 'react-i18next';
import { ChangeEvent } from 'react';

const TextAreaWithEmojiPicker = ({
  currentValue,
  formItemLabel,
  formItemName,
  maxLength,
  onChange,
  placeholder,
  required,
  rules,
}: {
  currentValue: string;
  formItemLabel: string;
  formItemName: string;
  maxLength: number;
  onChange: Function;
  placeholder: string;
  required: boolean;
  rules: Rule[];
}) => {
  const { t } = useTranslation();
  return (
    <div className="relative">
      <div className="absolute right-0">
        <EmojiPicker
          onEmojiSelect={(emoji) => {
            if (currentValue.length <= maxLength - 2) {
              onChange(currentValue + emoji);
            }
          }}
        />
      </div>
      <Form.Item
        required={required}
        name={formItemName}
        label={formItemLabel}
        rules={rules}
        extra={
          <p className={`smallParagraph mt-[4px] text-text2`}>
            {t('common.textAreaExtraText', {
              currentLength: currentValue?.length || 0,
              maxLength,
            })}
          </p>
        }
      >
        <Input.TextArea
          placeholder={placeholder}
          rows={5}
          maxLength={maxLength}
          onPaste={(e: any) => {
            const newValue = e.clipboardData
              .getData('text/plain')
              .slice(0, maxLength - currentValue.length);
            const position = e.target.selectionStart;
            onChange(currentValue.slice(0, position) + newValue + currentValue.slice(position));
            e.preventDefault();
          }}
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
            onChange(
              currentValue.length === maxLength && e.target.value.length >= maxLength
                ? currentValue
                : e.target.value.slice(0, maxLength)
            );
          }}
        />
      </Form.Item>
    </div>
  );
};

export default TextAreaWithEmojiPicker;
